module.exports = __webpack_public_path__ + "static/media/weddingcatering.20a998f6.png";